<mat-toolbar color="primary">
  <mat-toolbar-row class="mat-elevation-z2 main-toolbar">
    <button class="nav-toggler" mat-icon-button (click)="onToggleSidenav()">
      <mat-icon aria-label="Menu">menu</mat-icon>
    </button>
    <ul class="appNameVersion">
      <li class="logo" *ngIf="logoApp">
        <a routerLink="/">
          <fa-icon [icon]="logoApp"></fa-icon>
        </a>
      </li>
      <li *ngIf="appName">
        <a class="app-name" routerLink="/">{{ appName }}</a>
      </li>
    </ul>

    <ul class="menu-links" *ngIf="isAuth">
      <li *ngIf="userIsAdmin() && isAuth && clientForm">
        <form [formGroup]="clientForm" class="clientForm" *ngIf="!isLoadingClients">
          <mat-form-field appearance="fill" class="clientFormField">
            <mat-label class="label">Client</mat-label>
            <mat-select formControlName="client" class="matSelect">
              <mat-option *ngFor="let client of clients" [value]="client" class="matOption">
                {{ client.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </li>
      <li *ngIf="user" class="flex">
        <app-notification></app-notification>

        <app-user-menu [user]="user"></app-user-menu>
      </li>
    </ul>

    <ul class="version" *ngIf="!isAuth">
      <li>version {{ appVersion }}</li>
    </ul>
  </mat-toolbar-row>
</mat-toolbar>